import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ApolloProvider} from "react-apollo";
import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from "apollo-boost";
import {BrowserRouter as Router} from "react-router-dom";
import Route from "react-router-dom/Route";
import LoginApp from "./main/LoginApp";
import InscriptionApp from "./main/InscriptionApp";
import {MagicLinkRedirection} from "./components/SSOSignInForm"
import SSOLoginApp from "./main/SSOLoginApp";
import InscriptionFunColApp from "./main/InscriptionFuncolApp";
import {CIBER_SCHEMA} from "./apollo/Schema";
import InscriptionBacAffiliateApp from "./main/InscriptionBacAffiliateApp";
import InscriptionBacNoAffiliateApp from "./main/InscriptionBacNoAffiliateApp";
import KJUR from 'jsrsasign';
import SSOApp from './main/SSOApp';
import {getLoggedUser} from "./util/Utils";

let httpLink;

if (process.env.PUBLIC_URL.indexOf('appsprod') >= 0) {
  httpLink = new HttpLink({uri: 'https://appsprod.cibercolegios.com/api/vendorsauth'});
} else {
  httpLink = new HttpLink({uri: 'https://appstest.cibercolegios.com/api/vendorsauth'});
  //httpLink = new HttpLink({uri: 'http://localhost:8080/vendorsauth'});
}

const authLink = new ApolloLink((operation, forward) => {

  let loggedUser = getLoggedUser();
  let token = sessionStorage.getItem("auth_token");
  if(!token && loggedUser!=null){
    const payLoad = {
      sub: `${loggedUser.data.numeroDocumento}_2`,
      exp: Math.floor(Date.now() / 1000) + (60 * 60),
      customer: {
        documentNumber: loggedUser.data.numeroDocumento,
        documentType: loggedUser.data.tpIdentificacion,
        telephoneNumber: "NA",
        mail: loggedUser.profile.email,
        timeSession: "60",
        username: `${loggedUser.data.numeroDocumento}_2`,
        firstName: loggedUser.profile.firstName,
        lastName: loggedUser.profile.lastName,
        uid: loggedUser.UID,
        uidSignature: loggedUser.UIDSignature,
        signatureTimestap: loggedUser.signatureTimestamp
      }
    }
    const sHeader = JSON.stringify({ alg: "HS256", typ: "JWT" });
    token = KJUR.jws.JWS.sign("HS256", sHeader, payLoad, { utf8:  loggedUser.data.numeroDocumento });
    sessionStorage.setItem("auth_token", token);
  }
  operation.setContext({
    headers: {
      auth_token: token
    }
  });
  return forward(operation);
});

const client = new ApolloClient({
  link: authLink.concat(httpLink), // Chain it with the HttpLink
  cache: new InMemoryCache(),
  typeDefs: CIBER_SCHEMA
});

class App extends React.Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <div>
          <div className="container">
            <br/>
            <div className="row">
              <Router>
                  <Route path="/colsubsidio/bridge" component={SSOApp} />
                  <Route path="/colsubsidio/sso" component={SSOLoginApp} />
                  <Route path="/colsubsidio/inscripcion" component={InscriptionApp} />
                  <Route path="/colsubsidio/login" component={LoginApp} />
                  <Route path="/colsubsidio/bac/affiliate/inscripcion" component={InscriptionBacAffiliateApp} />
                  <Route path="/colsubsidio/bac/guest/inscripcion" component={InscriptionBacNoAffiliateApp} />
                  <Route path="/funcol/inscripcion" component={InscriptionFunColApp} />
                  <Route path="/colsubsidio/magic" component={MagicLinkRedirection} />
              </Router>
            </div>
          </div>
        </div>
      </ApolloProvider>
    );
  }
}

export default App;
